<div class="max-w-lg mx-auto flex-col pt-20 text-theme-text">
  <div class="flex-1 bg-theme-surface rounded-t-3xl min-h-[calc(100vh-5rem)]">

    <!-- Header -->
    <div class="flex flex-row pt-6 px-4 pb-4 items-center justify-center relative">
      <!-- Back button for pages 2 and 3 -->
      <div *ngIf="page !== 1" class="absolute left-4">
        <app-circle-button class="hover:bg-gray-100" [icon]="'fa-arrow-left'" size="12" type="solid" fontSize="xl" (onClick)="backClicked()"></app-circle-button>
      </div>
      <!-- Close button for page 1 -->
      <div *ngIf="page === 1" class="absolute right-4">
        <app-circle-button class="hover:bg-gray-100" [icon]="'fa-times'" size="12" type="solid" fontSize="xl" (onClick)="closeClicked()"></app-circle-button>
      </div>
      <div class="text-3xl break-words text-center">
        <span *ngIf="page === 1">Mina biljetter</span>
        <span *ngIf="page === 2">Välj restaurang</span>
        <span *ngIf="page === 3">Sammanfattning</span>
      </div>
    </div>

    <!-- PAGE 1: Voucher Selection -->
    <div *ngIf="page === 1">
      <!-- Sub Header -->
      <div class="text-lg text-theme-text2 text-center px-8 pb-6">
        {{activeVouchers.length>0?getString("Välj biljetter som du vill använda"):getString("Här visas dina aktiva och inaktiva biljetter.")}}
      </div>

      <!-- Main Content -->
      <div class="px-8" *ngIf="!isLoading">

        <!-- Vouchers List -->
        <div *ngIf="vouchers.length > 0" class="mt-4">
          <div *ngFor="let voucher of vouchers" class="mb-4">

            <!-- Voucher Item -->
            <div class="flex space-x-3 w-full items-center py-2"
                 [class.opacity-50]="!voucher.active"
                 [class.cursor-pointer]="voucher.active">
              <!-- Only show checkbox for active vouchers -->
              <div class="mt-0.5" *ngIf="voucher.active">
                <app-box-for-checkbox
                  [ngModel]="isSelected(voucher.voucher_id)"
                  (ngModelChange)="toggleVoucher(voucher.voucher_id)">
                </app-box-for-checkbox>
              </div>
              <!-- Empty space for inactive vouchers to maintain alignment -->
              <div class="mt-0.5 w-4" *ngIf="!voucher.active"></div>

              <div class="flex-1 min-w-0" (click)="handleVoucherClick(voucher)">
                <div class="text-base flex">
                  <div class="flex-1 font-bold" [class.text-theme-text]="voucher.active" [class.text-theme-text2]="!voucher.active">
                    <span class="break-words">{{voucher.name}}</span>
                  </div>
                  <div class="ml-2 whitespace-nowrap text-end">
                    <span class="tabular-nums" [class.text-theme-text3]="voucher.active" [class.text-theme-text2]="!voucher.active">{{formatPrice(displayPriceCent(voucher))}}</span>
                  </div>
                </div>
                <!-- Optional message -->
                <div *ngIf="voucher.message" class="text-sm mt-1" [class.text-theme-text3]="voucher.active" [class.text-theme-text2]="!voucher.active">
                  {{voucher.message}}
                </div>
                <!-- Activation timestamp for inactive vouchers -->
                <div *ngIf="!voucher.active && voucher.applied" class="text-sm text-theme-text2 mt-1">
                  {{getActivationText(voucher)}}
                </div>
              </div>
            </div>

          </div>
        </div>

        <!-- Empty State -->
        <div *ngIf="vouchers.length === 0 && activeVouchers.length === 0 && inactiveVouchers.length === 0" class="mt-10 p-8 bg-theme-surface2 rounded-xl text-center">
          <p class="text-theme-text2">{{getString("Inga aktiva biljetter")}}</p>
        </div>

        <!-- No active vouchers but has inactive -->
        <div *ngIf="activeVouchers.length === 0 && (inactiveVouchersToday.length > 0 || inactiveVouchersOlder.length > 0) && displayMode === 'active'"
             class="mt-10 p-8 bg-theme-surface2 rounded-sm text-center text-theme-text3">
          <p class="text-theme-text3">{{getString("Inga aktiva biljetter")}}</p>
        </div>

        <!-- Show/Hide inactive vouchers toggle -->
        <div *ngIf="shouldShowToggleButton()" class="mt-8 flex items-center space-x-2 cursor-pointer justify-center" (click)="cycleDisplayMode()">
          <i class="fas fa-history fa-lg text-theme-text3"></i>
          <div class="text-theme-text3">{{getToggleButtonText()}}</div>
          <div class="h-12"></div>
        </div>

        <!-- Add padding for fixed button -->
        <div class="h-24"></div>
      </div>

      <!-- Loading Spinner -->
      <div *ngIf="isLoading" class="flex items-center justify-center mt-20">
        <app-loading-spinner size="2xl"></app-loading-spinner>
      </div>
    </div>

    <!-- PAGE 2: Vendor Selection -->
    <div *ngIf="page === 2">
      <!-- Sub Header -->
      <div class="text-lg text-theme-text2 text-center px-8 pb-6">
        {{ selectedVouchers.size==1?getString("Var vill du använda din biljett"):getString("Var vill du använda dina biljetter")}}
      </div>

      <!-- Vendor List -->
      <div class="px-8">
        <div *ngIf="vendors.length > 0" class="mt-4 flex flex-col gap-3">
          <label *ngFor="let vendor of vendors"
                 class="flex items-center px-4 py-3 rounded-lg cursor-pointer bg-theme-surface2 border-2 transition-colors"
                 [class.border-theme-primary]="selectedVendor === vendor.id"
                 [class.border-theme-surface2]="selectedVendor !== vendor.id">

            <input type="radio"
                   name="vendor-selection"
                   [value]="vendor.id"
                   [(ngModel)]="selectedVendor"
                   class="hidden">

            <div class="flex items-center gap-3 w-full">
              <div class="relative w-5 h-5 flex items-center justify-center">
                <div *ngIf="selectedVendor === vendor.id"
                     class="fas fa-circle-dot text-theme-primary fa-lg">
                </div>
                <div *ngIf="selectedVendor !== vendor.id"
                     class="far fa-circle text-theme-primary fa-lg">
                </div>
              </div>

              <div class="flex-grow">
                <span class="text-base text-theme-text"
                      [class.font-bold]="selectedVendor === vendor.id"
                      [class.font-medium]="selectedVendor !== vendor.id">
                  {{vendor.name}}
                </span>
              </div>
            </div>
          </label>
        </div>

        <!-- Empty State -->
        <div *ngIf="vendors.length === 0" class="mt-10 p-8 bg-theme-surface2 rounded-xl text-center">
          <p class="text-theme-text2">Inga restauranger tillgängliga</p>
        </div>

        <!-- Add padding for fixed button -->
        <div class="h-24"></div>
      </div>
    </div>

    <!-- PAGE 3: Summary -->
    <div *ngIf="page === 3">
      <!-- Sub Header -->
<!--      <div class="text-lg text-theme-text2 text-center px-8 pb-6">-->
<!--        Bekräfta aktivering-->
<!--      </div>-->

      <!-- Summary Content -->
      <div class="px-8">
        <!-- Selected Vouchers Section -->
        <div class="my-6">
          <h3 class="text-lg font-bold text-theme-text mb-3">Valda biljetter</h3>
          <div class="bg-theme-surface2 rounded-lg p-4">
            <div *ngFor="let group of getGroupedVouchers(); let last = last"
                 [class.mb-3]="!last"
                 [class.pb-3]="!last"
                 [class.border-b]="!last"
                 class="border-theme-divider">
              <div class="flex justify-between items-start">
                <div class="flex-1">
                  <div class="font-bold text-theme-text">
                    <span *ngIf="group.count > 1">{{group.count}}x </span>{{group.name}}
                  </div>
                  <div *ngIf="group.message" class="text-sm text-theme-text3 mt-1">{{group.message}}</div>
                </div>
                <div class="text-theme-text3 tabular-nums ml-4">{{formatPrice(group.price_cent)}}</div>
              </div>
            </div>
            <!-- Total -->
            <div class="flex justify-between items-center pt-3 mt-3 border-t border-theme-divider">
              <span class="font-bold text-theme-text">Totalt</span>
              <span class="font-bold text-theme-text tabular-nums">{{getTotalPrice()}}</span>
            </div>
          </div>
        </div>

        <!-- Selected Vendor Section -->
        <div *ngIf="selectedVendor" class="mb-6">
          <h3 class="text-lg font-bold text-theme-text mb-3">Restaurang</h3>
          <div class="bg-theme-surface2 rounded-lg p-4">
            <div class="text-theme-text font-medium">{{getSelectedVendorName()}}</div>
          </div>
        </div>

        <div class="mt-8">
          <h3 class="text-lg font-bold text-theme-text mb-3">Så här gör du</h3>
          <div class="mt-1 text-sm text-theme-text">
            <p class="text-justify">{{getString(translate.STRING_ACTIVATE1)}}</p>
            <p class="mt-3">{{getString(translate.STRING_ACTIVATE2)}}</p>
          </div>
        </div>

        <!-- Add padding for bottom -->
        <div class="h-36"></div>
      </div>
    </div>

  </div>

  <!-- Fixed Action Button for pages 1 and 2 -->
  <div *ngIf="(page === 1 && vouchers.length > 0) || (page === 2 && vendors.length > 0)"
       class="max-w-lg mx-auto fixed bottom-0 left-0 right-0 p-4 pb-safe animate-fadein animate-duration-300 z-20 pointer-events-none">
    <div class="pointer-events-auto">
      <app-action-button
        [text]="getButtonText()"
        (onClick)="onActionButtonClick()"
        [itemCount]="0"
        [disabled]="(page === 1 && getSelectedCount() === 0) || (page === 2 && !selectedVendor)">
      </app-action-button>
    </div>
  </div>

  <!-- Dragger Component for page 3 -->
  <div *ngIf="page === 3" class="max-w-lg mx-auto fixed bottom-0 left-0 right-0 p-4 pb-safe animate-fadein animate-duration-300 z-20 bg-theme-surface">
    <div class="max-w-80 mx-auto">
      <app-slide-to-activate
        [text]="getString('Aktivera 1 min')"
        [consumedText]="getString('Förbrukad')"
        (activated)="onSliderActivated()">
      </app-slide-to-activate>
    </div>
  </div>
</div>
